export type NavLink = { id: string; label: string };

export const navLinks: NavLink[] = [
  { id: 'recap', label: '前情回顾' },
  { id: 'timeline', label: '事件全貌' },
  { id: 'background', label: '背景资料' },
  { id: 'reversals', label: '反转记录' },
  { id: 'updates', label: '后续进度' },
  { id: 'trending', label: '热门吃瓜' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '320+', label: '已整理事件' },
  { value: '1,860', label: '反转记录' },
  { value: '24h', label: '热点更新' },
  { value: '51万+', label: '补课群众' },
];

export const tickerItems = [
  '《星河未眠》临阵换角风波 · 已整理',
  '城市音乐节改期疑云 · 反转 3 次',
  '暑期档票房争论 · 背景已补全',
  '综艺剪辑争议 · 前情回顾已上线',
  '时尚盛典位次话题 · 后续进度跟进中',
];

export type RecapItem = {
  step: string;
  title: string;
  desc: string;
  tag: string;
};

export const recapItems: RecapItem[] = [
  {
    step: '01',
    title: '事件起点：官宣阵容和传闻对不上',
    desc: '某部备受期待的新剧在同一天放出了主创海报，但海报上的女二号与三个月前流传的路透照片并非同一人，粉丝第一时间在评论区提出疑问。',
    tag: '起点',
  },
  {
    step: '02',
    title: '第一波发酵：物料时间线出现矛盾',
    desc: '有网友整理出开机照、片场合照和官方花絮，发现这位演员的戏份在后期物料里被大量替换，相关话题一小时内冲上热搜。',
    tag: '发酵',
  },
  {
    step: '03',
    title: '当事人回应：两边工作室先后发声',
    desc: '当天傍晚，两侧工作室分别发布声明，一方称"因个人原因退出"，另一方称"从未收到正式邀约"，两份说法直接冲突，事件从换角升级为罗生门。',
    tag: '回应',
  },
  {
    step: '04',
    title: '舆论分化：路人和粉丝看法彻底分裂',
    desc: '支持原演员的认为是被"低调换掉"，支持剧方的则拿档期冲突说事，中立网友更关心成片质量，评论区开始分成明显的三派。',
    tag: '分化',
  },
];

export type TimelineItem = {
  date: string;
  title: string;
  desc: string;
  kind: '起点' | '发酵' | '回应' | '反转' | '进展';
};

export const timelineItems: TimelineItem[] = [
  {
    date: '08 / 02',
    title: '项目正式官宣',
    desc: '剧集《星河未眠》公布主创阵容，海报中女二号为演员林知夏（虚构人物），官方文案强调"全新面孔"。',
    kind: '起点',
  },
  {
    date: '08 / 05',
    title: '开机照流出',
    desc: '片场路透显示林知夏已进组，与导演郑文川（虚构人物）合影，配文"正式开拍"。',
    kind: '起点',
  },
  {
    date: '08 / 19',
    title: '首次出现"换人"传闻',
    desc: '某论坛帖称"女主旁边那位已经变了"，但当时没有物料佐证，帖子上线两小时后被删除。',
    kind: '发酵',
  },
  {
    date: '08 / 27',
    title: '官方花絮缺镜',
    desc: '官方放出的幕后花絮里，多处本应出现女二号的镜头被剪短或替换成远景，细心网友做了逐帧对比。',
    kind: '发酵',
  },
  {
    date: '09 / 03',
    title: '新版海报上线',
    desc: '主创海报更新，女二号位置由演员江晚（虚构人物）担任，话题在十分钟内进入热搜前十。',
    kind: '回应',
  },
  {
    date: '09 / 03',
    title: '林知夏工作室声明',
    desc: '声明称"因个人工作安排调整，已于开机后友好协商退出项目"，未提及具体原因。',
    kind: '回应',
  },
  {
    date: '09 / 04',
    title: '剧方回应出现分歧',
    desc: '剧方称"从未与林知夏完成正式签约，仅为前期接触"，与工作室声明的"退出项目"说法互相矛盾。',
    kind: '反转',
  },
  {
    date: '09 / 06',
    title: '前制片助理爆料',
    desc: '一位自称前制片助理的账号放出聊天记录截图，称矛盾核心是创作理念而非档期，随后该账号注销。',
    kind: '反转',
  },
  {
    date: '09 / 09',
    title: '江晚首次公开回应',
    desc: '江晚在采访中表示"进组时剧本已经完成调整，我只是把角色演好"，被解读为侧面证实剧本确有改动。',
    kind: '进展',
  },
  {
    date: '09 / 12',
    title: '剧方关闭评论区',
    desc: '剧集官微关闭了新物料下的评论，仅保留转发，事件进入低热度但持续发酵的阶段。',
    kind: '进展',
  },
];

export type BackgroundCard = {
  icon: string;
  title: string;
  desc: string;
  points: string[];
};

export const backgroundCards: BackgroundCard[] = [
  {
    icon: 'ri-film-line',
    title: '项目背景',
    desc: '这是一部定位"都市悬疑+群像"的中成本剧集，从立项到开拍历时一年多，女二号在剧本里是推动主线的关键人物。',
    points: ['立项时间早于演员接触', '女二号戏份集中在后半程', '平台对成片节奏有明确要求'],
  },
  {
    icon: 'ri-links-line',
    title: '人物关系梳理',
    desc: '把当事人、剧方和平台三个方向的关系理清，很多矛盾其实来自"谁有最终决定权"这件事。',
    points: ['演员方 → 经纪与工作室', '剧方 → 导演与制片两条线', '平台 → 采购与排播话语权'],
  },
  {
    icon: 'ri-building-2-line',
    title: '行业惯例',
    desc: '拍摄期换角在行业内并不罕见，常见原因包括档期、身体状态、创作分歧和合约条款，但公开说明通常非常克制。',
    points: ['合约分"意向"与"正式"两阶段', '开机后换角成本明显更高', '对外口径往往统一为"档期原因"'],
  },
  {
    icon: 'ri-history-line',
    title: '相关旧事',
    desc: '这位导演此前两部作品都出现过类似的说法，上一次是配角戏份大幅删减，最终也未给出公开解释。',
    points: ['上部作品曾有"角色消失"争议', '习惯在后期重新调整结构', '团队对外沟通一贯低调'],
  },
];

export type ReversalItem = {
  round: string;
  before: string;
  after: string;
  note: string;
};

export const reversalItems: ReversalItem[] = [
  {
    round: '反转 01',
    before: '一开始大家都以为是"档期冲突"，属于正常的行程调整。',
    after: '工作室声明用的是"友好协商退出"，说明并非单纯的时间冲突。',
    note: '措辞差异是第一个关键线索。',
  },
  {
    round: '反转 02',
    before: '剧方称双方"从未正式签约"，只是前期接触。',
    after: '开机合影、片场路透和"正式开拍"配文都指向已经进组拍摄。',
    note: '物料比声明更诚实。',
  },
  {
    round: '反转 03',
    before: '有爆料称是女二号"临时加价"导致谈崩。',
    after: '前制片助理的聊天记录指向创作理念分歧，价格说法没有更多佐证。',
    note: '爆料账号随后注销，可信度打折。',
  },
  {
    round: '反转 04',
    before: '网友以为换角之后剧情会大幅重写，担心成片质量。',
    after: '江晚回应"进组时剧本已完成调整"，说明改动早于换角，顺序被倒置了。',
    note: '因果顺序是这段最大的误解。',
  },
  {
    round: '反转 05',
    before: '事情看起来会以双方各自发声明收场，热度自然回落。',
    after: '剧方关闭评论区，反而让讨论转移到其他平台继续，长尾热度被延续。',
    note: '关闭评论不等于事件结束。',
  },
];

export type UpdateItem = {
  date: string;
  status: string;
  tone: 'primary' | 'accent' | 'secondary';
  title: string;
  desc: string;
};

export const updateItems: UpdateItem[] = [
  {
    date: '09 / 12',
    status: '进行中',
    tone: 'primary',
    title: '剧方关闭评论区，暂未追加说明',
    desc: '官微仅保留转发，未回应"合约"与"剧本调整"两个核心疑问。',
  },
  {
    date: '09 / 15',
    status: '有进展',
    tone: 'secondary',
    title: '平台排播页面更新',
    desc: '项目仍按原计划出现在平台的待播清单里，未见延期或撤档迹象。',
  },
  {
    date: '09 / 18',
    status: '有进展',
    tone: 'secondary',
    title: '林知夏接下新项目',
    desc: '其工作室官宣了另一部作品的合作，被普遍解读为"已经翻篇"。',
  },
  {
    date: '09 / 22',
    status: '待确认',
    tone: 'accent',
    title: '江晚戏份占比成新话题',
    desc: '新预告中女二号镜头明显增多，网友开始讨论角色被"加重"还是原本如此。',
  },
  {
    date: '09 / 26',
    status: '待确认',
    tone: 'accent',
    title: '导演访谈预告释出',
    desc: '一段未播出的访谈片段被放出，导演提到"选角永远服务于故事"，未直接回应换角。',
  },
  {
    date: '09 / 30',
    status: '持续跟进',
    tone: 'primary',
    title: '本页持续更新中',
    desc: '成片上线前后预计仍有新的信息出现，我们会把新增内容追加到下方时间线。',
  },
];

export type TrendingTopic = {
  title: string;
  category: string;
  heat: string;
  summary: string;
  tags: string[];
  progress: number;
};

export const trendCategories = ['全部', '影视', '综艺', '音乐', '时尚', '网络'];

export const trendingTopics: TrendingTopic[] = [
  {
    title: '城市音乐节临时改期',
    category: '音乐',
    heat: '92.4万',
    summary: '官方先称"天气原因"，两小时后被现场搭建照片打脸，改期原因出现两套说法。',
    tags: ['已补全', '反转 3 次'],
    progress: 88,
  },
  {
    title: '暑期档票房口水战',
    category: '影视',
    heat: '76.1万',
    summary: '两部影片的排片之争从预售吵到口碑，背后其实是一整套分账逻辑的差别。',
    tags: ['背景齐', '数据流'],
    progress: 72,
  },
  {
    title: '综艺剪辑争议',
    category: '综艺',
    heat: '68.9万',
    summary: '嘉宾发言被拼接顺序调换，正片和会员版两版内容对不上，争议点集中在剪辑权。',
    tags: ['已补全', '含时间线'],
    progress: 81,
  },
  {
    title: '时尚盛典位次讨论',
    category: '时尚',
    heat: '54.3万',
    summary: '一张合影站位引发解读，粉丝与品牌方各执一词，其实涉及的是合作优先级。',
    tags: ['轻量补课', '理性向'],
    progress: 64,
  },
  {
    title: '短剧爆红后的版权拉扯',
    category: '网络',
    heat: '47.8万',
    summary: '一部小成本短剧意外走红，原著方与制作方就改编边界隔空过招，条款细节是关键。',
    tags: ['进行中', '含背景'],
    progress: 58,
  },
  {
    title: '巡演临时加场疑云',
    category: '音乐',
    heat: '41.2万',
    summary: '加场通告来得突然，座位图和场馆容量对不上，被怀疑是先售罄再造势。',
    tags: ['待确认', '反转 1 次'],
    progress: 49,
  },
  {
    title: '剧集二番之争',
    category: '影视',
    heat: '38.6万',
    summary: '片头顺序和海报位次不一致，番位问题再次被摆上台面，涉及的是合同里的署名条款。',
    tags: ['已补全', '冷知识'],
    progress: 69,
  },
  {
    title: '内容平台互呛事件',
    category: '网络',
    heat: '33.5万',
    summary: '两家平台先后发布"致用户的一封信"，看似服务用户，实际围绕的是独家内容。',
    tags: ['背景齐', '简明版'],
    progress: 55,
  },
];

export type FaqItem = {
  q: string;
  a: string;
};

export const faqs: FaqItem[] = [
  {
    q: '「吃瓜补课」和普通新闻有什么不一样？',
    a: '我们不追第一时间的快讯，而是把一件事的起点、时间线、背景、反转和后续整理成一条能连贯读完的路径。补课的目的不是站队，而是让你在一页内看清"事情是怎么走到今天的"。',
  },
  {
    q: '为什么每篇都要单独列「反转记录」？',
    a: '因为大部分争执其实来自信息更新不及时。把"原来的说法"和"后来被推翻的点"并排放，能最快消除因为只看到中间一段而产生的误解，也避免把旧结论当成新事实转发。',
  },
  {
    q: '内容里的时间和人名可以直接引用吗？',
    a: '站内案例为便于说明结构，使用经过处理的示例人物与情节。涉及真实事件时，我们只呈现已公开发布的信息，并标注来源与时间，不做主观定性，也不替任何一方下结论。',
  },
  {
    q: '更新频率是多久一次？',
    a: '热点事件在出现明显进展的 24 小时内会补充时间线；长尾事件按周复盘。页面上每条后续进度都带有日期，你可以根据日期判断自己看到的是不是最新状态。',
  },
  {
    q: '可以提交自己关注的瓜吗？',
    a: '可以。如果你有完整的公开信息线索，欢迎通过首页底部的邮箱联系我们。我们更看重"有公开来源"的线索，这样整理出来的时间线才经得起回看。',
  },
  {
    q: '看完还是觉得有出入怎么办？',
    a: '欢迎直接指出具体条目和对应的公开信息，我们会核对后更正，并在"后续进度"里注明修改时间。补课内容的价值在于经得起复盘，而不是一次性看完就算。',
  },
];

export type Testimonial = {
  name: string;
  role: string;
  text: string;
  avatar: string;
};

export const testimonials: Testimonial[] = [
  {
    name: '桃子不加冰',
    role: '通勤追热点',
    text: '午休十分钟就能把一件事从头到尾看完，反转记录那一栏是真的救命，再也不怕把旧瓜当成新瓜了。',
    avatar:
      'https://readdy.ai/api/search-image?query=portrait%20of%20a%20cheerful%20young%20woman%20with%20short%20dark%20hair%2C%20warm%20cream%20studio%20backdrop%2C%20soft%20natural%20light%2C%20friendly%20editorial%20headshot%2C%20muted%20red%20and%20olive%20tones&width=300&height=300&seq=chigua-user-01&orientation=squarish',
  },
  {
    name: '阿哲同学',
    role: '理性围观派',
    text: '难得的是它不催你站队，只把时间和背景摆出来。和朋友讨论的时候终于不用各说各的版本。',
    avatar:
      'https://readdy.ai/api/search-image?query=portrait%20of%20a%20calm%20young%20man%20wearing%20glasses%2C%20warm%20cream%20studio%20backdrop%2C%20soft%20natural%20light%2C%20friendly%20editorial%20headshot%2C%20muted%20green%20and%20amber%20tones&width=300&height=300&seq=chigua-user-02&orientation=squarish',
  },
  {
    name: '小满同学',
    role: '内容从业者',
    text: '专业味很足，行业惯例和合同条款这种解释特别实用，比刷十条碎片消息有用多了。',
    avatar:
      'https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20young%20woman%20with%20long%20hair%2C%20warm%20cream%20studio%20backdrop%2C%20soft%20natural%20light%2C%20friendly%20editorial%20headshot%2C%20warm%20terracotta%20tones&width=300&height=300&seq=chigua-user-03&orientation=squarish',
  },
  {
    name: '一颗西瓜籽',
    role: '吃瓜群众',
    text: '界面清爽，看累了热点还能顺手翻翻热门吃瓜，进度条一眼就知道哪些已经整理完了。',
    avatar:
      'https://readdy.ai/api/search-image?query=portrait%20of%20a%20relaxed%20young%20person%20with%20curly%20hair%2C%20warm%20cream%20studio%20backdrop%2C%20soft%20natural%20light%2C%20friendly%20editorial%20headshot%2C%20muted%20amber%20and%20green%20tones&width=300&height=300&seq=chigua-user-04&orientation=squarish',
  },
];

export const aboutPrinciples = [
  {
    icon: 'ri-scales-3-line',
    title: '只摆事实，不替下结论',
    desc: '公开信息按时间排列，争议点分开呈现，把判断留给读者。',
  },
  {
    icon: 'ri-refresh-line',
    title: '有更新就标注时间',
    desc: '每条进展都带日期，让"最新"这件事看得见、查得到。',
  },
  {
    icon: 'ri-book-open-line',
    title: '背景先于立场',
    desc: '先把行业惯例和人物关系讲清楚，很多争执自然就散了。',
  },
];

export const siteContact = {
  email: 'hi@51chigua.example.com',
  slogan: '吃瓜不掉队，补课看这里。',
};